var _defs, _image, _rect, _path, _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGray0(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 3029.71 2942.07",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        stroke: #1e7faf;\n        stroke-width: 10.54px;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-1, .cls-3, .cls-4, .cls-5, .cls-7, .cls-6 {\n        fill: #fff;\n      }\n\n      .cls-2, .cls-8 {\n        fill: none;\n      }\n\n      .cls-9 {\n        fill: #3399bf;\n      }\n\n      .cls-9, .cls-10, .cls-11, .cls-8, .cls-12, .cls-13, .cls-7, .cls-14, .cls-15, .cls-16 {\n        stroke-width: 0px;\n      }\n\n      .cls-10 {\n        fill: #007faf;\n      }\n\n      .cls-3 {\n        stroke-width: .59px;\n      }\n\n      .cls-3, .cls-4, .cls-5, .cls-6 {\n        stroke: #1d1d1b;\n      }\n\n      .cls-11 {\n        fill: #d9d9d9;\n      }\n\n      .cls-12 {\n        fill: #fdb636;\n      }\n\n      .cls-13 {\n        fill: #2a3955;\n      }\n\n      .cls-17 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-4 {\n        stroke-width: .63px;\n      }\n\n      .cls-5 {\n        stroke-width: .97px;\n      }\n\n      .cls-14 {\n        fill: #1e7faf;\n      }\n\n      .cls-15 {\n        fill: #66b2cf;\n      }\n\n      .cls-16 {\n        fill: #f0f3f2;\n      }\n\n      .cls-6 {\n        stroke-width: 1.04px;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M2993.02,1481.67c0,617.99-947.21,1118.97-1565.2,1118.97S308.85,2099.66,308.85,1481.67,908.73,698.05,1427.83,362.7c1220.33-788.37,1565.2,500.98,1565.2,1118.97Z"
  })))), _image || (_image = /*#__PURE__*/React.createElement("image", {
    width: 300,
    height: 336,
    transform: "translate(33.02) scale(8.76)",
    xlinkHref: "WhatsApp Image 2024-05-23 \\xE0 13.20.37_cc1ec4a0.jpg"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    width: 3029.71,
    height: 2942.07
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1372.79,2698.89c-672.67,0-1217.97-545.3-1217.97-1217.97S700.13,262.95,1372.79,262.95h1458.8v2435.94h-1458.8Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 1427.83,
    cy: 1481.67,
    r: 1118.97
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 505.91,
    y: 2319.88,
    width: 1163.23,
    height: 115.55,
    rx: 20.86,
    ry: 20.86,
    transform: "translate(-394.61 223.77) rotate(-9.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1689.79,2215.65l172.14,10.08c17.07,1,21.17,24.33,5.45,31.08l-158.42,68.09c-9.61,4.13-20.56-1.79-22.37-12.09l-13.72-78.18c-1.81-10.31,6.47-19.6,16.92-18.99Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1439.17,1659.77s308.21-91.19,177.5-455.7c0,0,70.44,82.79,92.88,140.53l-5.99-51.88s180,180.08,110.07,355.37c-69.94,175.29-293.85,187.5-293.85,187.5l-80.6-175.83Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1693.8,1027.73l-568.91,426.34c-3.82,2.87-8.86,3.56-13.31,1.83l-662.78-257.2c-10.13-3.93-11.99-17.47-3.29-23.99l568.91-426.34c3.82-2.87,8.86-3.56,13.31-1.83l662.78,257.2c10.13,3.93,11.99,17.47,3.29,23.99Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-13",
    cx: 453.09,
    cy: 1274.27,
    rx: 22.92,
    ry: 77.24,
    transform: "translate(-169.15 73.49) rotate(-7.82)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M1588.88,1720.19c53.93,328.39-118.65,502.99-345.92,534.2-227.28,31.21-427.09-69.37-472.37-399.09-45.28-329.73,6.82-753.62,308.39-794.95,318.46-43.65,461.8,366.99,509.9,659.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M909.14,1668.46s-156.26,248.68,79.99,543.13c0,0-79.4-45.96-117.92-91.71l25.66,48.38s-189.63-86.2-219.36-295.98c-29.72-209.78,106.58-336.85,106.58-336.85l125.05,133.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1127.14,1562.1s-15.16,29.66-25.63,37.47l5.49-23.03s-17.45,48.01-31.47,51c-14.02,2.99-19.31,34.48-60.35,50.72-41.05,16.25-85.35,29.76-109.09,31.96l6.66,6.51s-45.88,2.06-54.2-9.53l-3.58,8.98s-116.7-44.44-144.5-113.83c-27.8-69.38-24.46-242.9,37.62-318.72,62.08-75.82,72.49-91.04,72.49-91.04,0,0,75.12-97.31,186.44-120.02l8.5-1.17s-35.81-22.66-84.64-.05c0,0,42.56-47.22,114.84-4.1,0,0-35.27-39.71-38.93-59.37,0,0,26.43,31.38,33.46,33.6,0,0-19.11-27.08-8.69-42.3,0,0,11.18,32.41,35.32,47.13,0,0-3.45-27.11,14.23-44.39,0,0-4.05,34.5,1.64,54.94,5.69,20.44,1.72,12.49,1.72,12.49,0,0,2.09-61.82,61.84-67.9,0,0-25.66,16.25-27.37,38.77l-1.83,7.68s24.21-33.21,54.23-39.27c32.75-6.62,54.52-2.18,54.52-2.18,0,0-65.93,10.11-64.67,33.28,0,0,140.67-33.11,303.59,123.8,162.92,156.91,138.89,332.07,138.89,332.07,0,0-21.71,108.01-111.73,145.83,0,0,40.3-42.67,39.3-49.95,0,0-64.73,60.87-134.24,79.96-69.51,19.09-186.41-33.81-224.53-94.35l7.21,24.47s-24.57-17.84-31.46-54.03c0,0-7.32,30.71-27.55,51.52l6.47-36.96Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 929.42,
    cy: 1496.76,
    rx: 174.5,
    ry: 195.72,
    transform: "translate(-194.99 140.36) rotate(-7.82)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-10",
    cx: 962.11,
    cy: 1485.87,
    rx: 113.89,
    ry: 125.63,
    transform: "translate(-193.2 144.71) rotate(-7.82)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-13",
    cx: 961.68,
    cy: 1486.75,
    rx: 76.13,
    ry: 78.45,
    transform: "translate(-193.33 144.66) rotate(-7.82)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 1007.07,
    cy: 1437.9,
    rx: 12.6,
    ry: 12.98,
    transform: "translate(-186.26 150.38) rotate(-7.82)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 953.66,
    cy: 1423.6,
    rx: 20.8,
    ry: 21.43,
    transform: "translate(-184.81 142.98) rotate(-7.82)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 1334.37,
    cy: 1427.21,
    rx: 180.64,
    ry: 202.61,
    transform: "translate(-181.76 194.81) rotate(-7.82)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-10",
    cx: 1336.36,
    cy: 1441.7,
    rx: 117.9,
    ry: 130.06,
    transform: "translate(-183.72 195.21) rotate(-7.82)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-13",
    cx: 1341.75,
    cy: 1443.07,
    rx: 78.81,
    ry: 81.21,
    transform: "translate(-183.85 195.96) rotate(-7.82)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 1308.41,
    cy: 1396.66,
    rx: 13.4,
    ry: 13.81,
    transform: "translate(-332.08 2382.26) rotate(-77.87)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 1350.67,
    cy: 1367.46,
    rx: 22.13,
    ry: 22.8,
    transform: "translate(-270.15 2400.52) rotate(-77.87)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1127.78,1560.05l-35.64,54.18c-2.26,3.44-2.24,7.63.05,10.91l51.89,74.25c7.91,11.32,25.21,9.38,30.43-3.4l36.45-89.3c2-4.89.33-10.24-4.17-13.38l-54.48-37.98c-8.05-5.61-19.14-3.48-24.53,4.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M815.54,1277.86c-55.99-49.92-104.91-134.69-104.91-134.69,32.71,18.79,81,22.15,177.03,22.68,22.79.12,48.26.09,76.85.06l-148.98,111.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1402.93,1183.21c40.46-63.16,64.71-157.99,64.71-157.99-26.43,26.91-72.03,43.17-164.36,69.56-21.91,6.26-46.45,13.1-73.99,20.78l173.64,67.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1152.92,1458.3s-32.69-167.4,50.97-236.75c83.66-69.35,159.94-30.52,159.94-30.52,0,0,46.35,25.11,104.29-16.85,0,0-17.49,81.84-104.49,70.29-81.2-10.79-128.37,22.66-128.37,22.66,0,0-61.51,46.18-82.34,191.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1110.52,1481.1s-13.65-170.02-112.9-214.25c-99.25-44.23-162.25,13.72-162.25,13.72,0,0-37.86,36.67-104.97,11.89,0,0,38.9,74.1,119.57,39.52,75.29-32.28,129.73-12.78,129.73-12.78,0,0,71.68,27.89,130.82,161.9Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1186.31,2288.95c3.06,22.28-7.05,36.08-23.9,52.53-14.81,14.45-34.58,32.74-58.57,36.03-20.54,2.82-41.34-7.87-57.99-14.97-24.92-10.63-41.85-22.97-45.3-48.08-3.19-23.21,5.66-53.6,23.89-70.27,14.64-13.4,35.73-15.15,58.58-18.29,25.65-3.52,47.87-13.94,66.56-2.53,18.69,11.41,33.85,44.65,36.72,65.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1489.7,2247.29c3.06,22.28-7.05,36.08-23.9,52.53-14.81,14.45-34.58,32.74-58.57,36.03-20.54,2.82-41.34-7.87-57.99-14.97-24.92-10.63-41.85-22.97-45.3-48.08-3.19-23.21,5.66-53.6,23.89-70.27,14.64-13.4,35.73-15.15,58.58-18.29,25.65-3.52,47.87-13.94,66.56-2.53,18.69,11.41,33.85,44.65,36.72,65.58Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "2543.1 1579.25 1788.63 1500.49 1669.25 601.24 2423.73 680 2543.1 1579.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1674.81 616.44 1565.89 667.47 1654.19 1563.47 2406.82 1628.31 2520.89 1568.02 2404.79 693.47 1674.81 616.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "2408.67 1642.23 1654.19 1563.47 1534.81 664.23 2289.29 742.98 2408.67 1642.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "2233.41 1060.81 2137.06 1002.28 1943.35 1321.15 1778.09 1220.76 1719.56 1317.1 1981.14 1476.01 2036.84 1384.32 2036.87 1384.34 2233.41 1060.81"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-14",
    points: "1541.42 673.98 1670.64 611.68 1664.79 603.6 1534.35 660.74"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 2286.27,
    y1: 746.93,
    x2: 2406.34,
    y2: 705.11
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M2616.05,512.75l-114.04,109.71c-5.19,4.99-13.43,5.35-18.32.81l-6.68-6.21c-4.89-4.54-4.64-12.35.54-17.34l114.04-109.71c5.19-4.99,13.43-5.35,18.32-.81l6.68,6.21c4.89,4.54,4.64,12.35-.54,17.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M2365.7,417.66l-24.8,156.29c-1.13,7.11-7.48,12.37-14.12,11.69l-9.07-.93c-6.64-.68-11.15-7.05-10.02-14.16l24.8-156.29c1.13-7.11,7.48-12.37,14.12-11.69l9.07.93c6.64.68,11.15,7.05,10.02,14.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M2142.59,410.49l41.92,152.59c1.91,6.94-1.71,14.36-8.04,16.48l-8.65,2.9c-6.33,2.12-13.06-1.82-14.97-8.76l-41.92-152.59c-1.91-6.94,1.71-14.36,8.04-16.48l8.65-2.9c6.33-2.12,13.06,1.82,14.97,8.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M2704.14,770.73l-157.98,9.21c-7.18.42-13.68-4.66-14.44-11.3l-1.04-9.06c-.76-6.63,4.5-12.4,11.68-12.82l157.98-9.21c7.18-.42,13.68,4.66,14.44,11.3l1.04,9.06c.76,6.63-4.5,12.4-11.68,12.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M2711.26,989.11l-153.76-37.4c-6.99-1.7-11.72-8.46-10.51-15.03l1.66-8.97c1.21-6.56,7.93-10.54,14.92-8.84l153.76,37.4c6.99,1.7,11.72,8.46,10.51,15.03l-1.66,8.97c-1.21,6.56-7.93,10.54-14.92,8.84Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGray0);
export default __webpack_public_path__ + "static/media/gray_0.67daf8979af073dfa6826eb89e920fb7.svg";
export { ForwardRef as ReactComponent };